import "../assets/styles/components/footer.scss";
import FooterLogo from "../assets/images/logo-bianco.svg";
import SupportMail from "../assets/icons/support-mail";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="mx-auto w-100 d-flex gap-3 flex-column flex-md-row px-3 py-2 w-100">
        <img className="d-none d-md-block" src={FooterLogo} />
        <div className="d-flex align-items-center ms-md-auto">
          <div className="d-flex align-items-center">
            <SupportMail className="me-2" color="#ffffff" size={24} />
            <a href="mailto:formazionerete@q8.it">
              <small>formazionerete@q8.it</small>
            </a>
          </div>
          <small className="ms-auto ms-md-5">
            Version: {process.env.REACT_APP_VERSION}
          </small>
        </div>
      </div>
    </footer>
  );
}
